export const WalletChainType = {
  SEPOLIA: "11155111",
  ETH: "1",
  PUSH: "42101",
  SOLANA: "EtWTRABZaYq6iMfeYKouRu166VU2xqa1"
};

export const MAINNET_CHAINIDS = [
  "5eykt4UsFv8P8NJdTREpY1vzqKqZKvdp",
  "1",
  "42161",
  "56",
  "43114",
  "devnet",
];
